import CommonFooter from "@components/organisms/common-footer";
import CommonHeader from "@components/organisms/common-header";
import CommonLayout from "@components/templates/common-layout";
import MemodCard from "@components/molecules/memod-card";
import { VideoModal } from "@components/molecules/video-modal";
import type { NextPage } from "next";
import { useReducer } from "react";
import Head from "next/head";

const AboutUs: NextPage = () => {
  const memos: any[] = [
    {
      id: 1324,
      files: [
        {
          field_name: "cover-image",
          url: "https://cdn.memod.com/images/Qjm1UE.jpg",
          size: "951",
          attributes: {
            height: "951",
            orientation: "portrait",
            unique_name: "images/Qjm1UE.jpg",
            width: "634",
          },
        },
      ],
      title: "A Memo on Memo’d",
      slug: "a-memo-on-memo-d",
      is_published: 1,
      writer: {
        displayname: "MemodTeam",
        photo: {
          url: "https://cdn.memod.com/images/06EPCe.jpg",
        },
      },
      type: {
        id: "1",
        name: "Single",
      },
    },
    {
      id: 1330,
      files: [
        {
          field_name: "cover-image",
          url: "https://cdn.memod.com/images/5cRC8b.jpg",
          size: "951",
          attributes: {
            height: "951",
            orientation: "portrait",
            unique_name: "images/5cRC8b.jpg",
            width: "634",
          },
        },
      ],
      title: "The origins of Memo'd",
      slug: "the-origins-of-memo-d",
      is_published: 1,
      writer: {
        displayname: "MemodTeam",
        photo: {
          url: "https://cdn.memod.com/images/06EPCe.jpg",
        },
      },
      type: {
        id: "1",
        name: "Single",
      },
    },
    {
      id: 1325,
      files: [
        {
          field_name: "cover-image",
          url: "https://cdn.memod.com/images/T0RNrw.jpg",
          size: "951",
          attributes: {
            height: "951",
            orientation: "portrait",
            unique_name: "images/T0RNrw.jpg",
            width: "634",
          },
        },
      ],
      title: "Memo'd: Our Story",
      slug: "memo-d-our-story",
      is_published: 1,
      writer: {
        displayname: "MemodTeam",
        photo: {
          url: "https://cdn.memod.com/images/06EPCe.jpg",
        },
      },
      type: {
        id: "1",
        name: "Single",
      },
    },
    {
      id: 1323,
      files: [
        {
          field_name: "cover-image",
          url: "https://cdn.memod.com/images/orBqHc.jpg",
          size: "951",
          attributes: {
            height: "951",
            orientation: "portrait",
            unique_name: "images/orBqHc.jpg",
            width: "634",
          },
        },
      ],
      title: "Memo’d Manifesto",
      slug: "memo-d-manifesto",
      is_published: 1,
      writer: {
        displayname: "MemodTeam",
        photo: {
          url: "https://cdn.memod.com/images/06EPCe.jpg",
        },
      },
      type: {
        id: "1",
        name: "Single",
      },
    },
  ];

  const [openVideo, setOpenVideo] = useReducer((state) => !state, false);

  return (
    <CommonLayout
      Header={<CommonHeader search hiddeBack showHomeLinks autocomplete />}
      Footer={<CommonFooter />}
      className="overflow-x-hidden"
    >
      <Head>
        <link rel="canonical" href="https://memod.com/about-us" />
      </Head>
      <VideoModal open={openVideo} onClose={setOpenVideo} />

      <main className="mx-auto flex w-full flex-col px-4">
        <div className="relative mt-16 flex flex-col items-center">
          <h1 className="mb-16 text-5xl font-normal text-white">About us</h1>
          <div
            className="video-preview w-full lg:w-[56rem] xl:w-[64rem]"
            style={{
              backgroundImage:
                "url(https://v2.memod.com/_nuxt/img/video-preview.e226390.jpg)",
              backgroundRepeat: "no-repeat",
              objectFit: "cover",
              objectPosition: "center",
            }}
          >
            <div className="play-button" onClick={setOpenVideo}>
              <div className="flex flex-row items-center">
                <div className="col-auto">
                  <div className="play-icon ml-1 flex items-center justify-center">
                    <img
                      src="https://v2.memod.com/_nuxt/img/play-icon.6f0a50e.svg"
                      alt="Play"
                      className="-mr-1 h-4 w-4"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="text-white">
                  <span>Watch video</span>
                </div>
              </div>
            </div>
          </div>
          <p className="text-lg text-white">
            Memo'd is a note-sharing app where you can find inspirations and
            ideas shared by our community of creators
          </p>
        </div>
        <hr className="about-hr" />
        <section className="key-features">
          <h1 className="h0">Key features</h1>
          <div className="container mx-auto">
            <div className="row mx-auto flex flex-col items-center justify-center lg:flex-row lg:space-x-4">
              <div className="mb-4 h-[28rem]">
                <div className="feature-card">
                  <figure>
                    <img
                      src="https://v2.memod.com/_nuxt/img/complex-ideas.2dc0115.jpg"
                      srcSet="https://v2.memod.com/_nuxt/img/complex-ideas.2dc0115.jpg 1x, https://v2.memod.com/_nuxt/img/complex-ideas.2dc0115.jpg 2x"
                      alt="Complex ideas"
                      loading="lazy"
                    />
                  </figure>
                  <div className="feature-card-body">
                    <h2>Complex ideas quickly understood</h2>
                    <p>
                      The unique 10-point structure of our Memos means no noise
                      or wasted time, just concentrated wisdom.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-4 h-[28rem]">
                <div className="feature-card">
                  <figure>
                    <img
                      src="https://v2.memod.com/_nuxt/img/create-and-share.e9cbcf8.jpg"
                      srcSet="https://v2.memod.com/_nuxt/img/create-and-share.e9cbcf8.jpg 1x, https://v2.memod.com/_nuxt/img/create-and-share.e9cbcf8.jpg 2x"
                      alt="Complex ideas"
                      loading="lazy"
                    />
                  </figure>
                  <div className="feature-card-body">
                    <h2>Create and share Memos</h2>
                    <p>
                      Let family, friends, colleagues and the wider world
                      benefit from your knowledge.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-4 h-[28rem]">
                <div className="feature-card">
                  <figure>
                    <img
                      src="https://v2.memod.com/_nuxt/img/save-and-organize.3c7b1d6.jpg"
                      srcSet="https://v2.memod.com/_nuxt/img/save-and-organize.3c7b1d6.jpg 1x, https://v2.memod.com/_nuxt/img/save-and-organize.3c7b1d6.jpg 2x"
                      alt="Complex ideas"
                      loading="lazy"
                    />
                  </figure>
                  <div className="feature-card-body">
                    <h2>Save and organize</h2>
                    <p>
                      Memo'd makes your most important ideas simpler to
                      communicate – and easier to find. Keep your valuable
                      insights safely stored in one place.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr className="about-hr" />
        <div className="who-we-are mx-auto">
          <h1 className="h0 !text-white">Who we are</h1>
          <p>
            Like you, we on the Memo’d team want to constantly improve and grow.
            Check out four of our profiles to learn more about our interests and
            journeys
          </p>
          <div className="row mx-auto flex flex-col items-center justify-center lg:flex-row lg:space-x-5">
            <div className="w-[235px]">
              <div className="collaborator-card">
                <figure>
                  <img
                    className="aspect-1"
                    src="https://v2.memod.com/_nuxt/img/stanley.4de701f.jpg"
                    alt="Stanley Yuan"
                    loading="lazy"
                  />
                </figure>
                <p className="text-truncate">Stanley Yuan</p>
                <a
                  href={`/memodian/memos`}
                  target="_blank"
                  className="rounded-full bg-memod-green-base text-white"
                >
                  View Profile
                </a>
              </div>
            </div>
            <div className="w-[235px]">
              <div className="collaborator-card">
                <figure>
                  <img
                    className="aspect-1"
                    src="https://v2.memod.com/_nuxt/img/karin.20f28a1.jpeg"
                    alt="Karin Richey"
                    loading="lazy"
                  />
                </figure>
                <p className="text-truncate">Karin Richey</p>
                <a
                  href={`/KarinRichey/memos`}
                  target="_blank"
                  className="rounded-full bg-memod-green-base text-white"
                >
                  View Profile
                </a>
              </div>
            </div>
            <div className="w-[235px]">
              <div className="collaborator-card">
                <figure>
                  <img
                    className="aspect-1"
                    src="https://v2.memod.com/_nuxt/img/tom.a9a7c66.jpeg"
                    alt="Tom Butler-Bowdon"
                    loading="lazy"
                  />
                </figure>
                <p className="text-truncate">Tom Butler-Bowdon</p>
                <a
                  href={`/TomButlerBowdon/memos`}
                  target="_blank"
                  className="rounded-full bg-memod-green-base text-white"
                >
                  View Profile
                </a>
              </div>
            </div>
            <div className="w-[235px]">
              <div className="collaborator-card">
                <figure>
                  <img
                    className="aspect-1"
                    src="https://v2.memod.com/_nuxt/img/cian.fab90c5.png"
                    alt="Cian Traynor"
                    loading="lazy"
                  />
                </figure>
                <p className="text-truncate">Cian Traynor</p>
                <a
                  href={`/Cian/memos`}
                  target="_blank"
                  className="rounded-full bg-memod-green-base text-white"
                >
                  View Profile
                </a>
              </div>
            </div>
          </div>
        </div>

        <hr className="about-hr" />

        <div className="feature">
          <h1 className="text-5xl !text-white">
            Learn more about the thinking behind Memo’d
          </h1>
          <div className="flex flex-col-reverse">
            <div className="col">
              <div className="feature-info open">
                <h1 className="d-flex d-xl-none hidden">
                  Learn more about the thinking behind Memo’d
                </h1>

                <div className="mx-auto flex w-full items-center justify-center">
                  <div className="md:w-1/2">
                    <img
                      src="https://v2.memod.com/_nuxt/img/behind-memod.88ca46e.jpg"
                      srcSet="https://v2.memod.com/_nuxt/img/behind-memod.88ca46e.jpg 1x, https://v2.memod.com/_nuxt/img/behind-memod@2x.84b007f.jpg 2x"
                      alt="Learn more about the thinking behind Memo’d "
                      className="img-fluid ml-5 h-[400px] object-fill"
                      loading="lazy"
                    />
                  </div>
                  <ul className="flex w-full flex-col text-white md:w-1/2">
                    <li className="">
                      <strong>New era.</strong>
                      The internet created an explosion in information, but
                      we’re at the limits of what our minds can organize and
                      absorb. We need a better system for gaining, storing,
                      retaining and sharing knowledge.
                    </li>
                    <li className="">
                      <strong>Insight hunger.</strong>
                      There’s a permanent demand for insights that can help us
                      succeed in life and work, but we need to separate the
                      valuable from the noise.
                    </li>
                    <li className="">
                      <strong>Shift to short form.</strong>
                      There’s a shift to shorter form content. The nature of
                      writing itself is changing. We’re seeing a transition from
                      the paragraph to the “information block” or text cell.
                    </li>
                    <li className="">
                      For more details on the thinking behind Memo'd, download
                      our White Paper:{" "}
                      <a
                        href="https://storage.googleapis.com/memod-public/Memo'd%20White%20Paper%202020.pdf"
                        target="_blank"
                        rel="nofollow"
                      >
                        Get The Memo? Crowdsourced wisdom and the shareable
                        notes revolution
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="about-hr" />

        <div className="feature">
          <h1 className="text-5xl !text-white">
            Memos: A new way of gaining and sharing knowledge
          </h1>
          <div className="flex flex-col-reverse">
            <div className="col">
              <div className="feature-info open">
                <h1 className="d-flex d-xl-none hidden">
                  Memos: A new way of gaining and sharing knowledge
                </h1>

                <div className="mx-auto flex w-full items-center justify-center sm:w-3/4">
                  <div className="">
                    <img
                      src="https://v2.memod.com/_nuxt/img/sharing-knowledge.a16cb67.jpg"
                      srcSet="https://v2.memod.com/_nuxt/img/sharing-knowledge.a16cb67.jpg 1x, https://v2.memod.com/_nuxt/img/sharing-knowledge@2x.31dfb87.jpg 2x"
                      alt="Learn more about the thinking behind Memo’d "
                      className="img-fluid ml-5 h-[400px] object-fill"
                      loading="lazy"
                    />
                  </div>
                  <ul className="flex w-full flex-col text-white md:w-1/2">
                    <li className="w-full">
                      If something’s worth knowing, it’s worth remembering – and
                      with as little effort as possible.
                    </li>
                    <li className="w-full">
                      A Memo is a note that makes any subject instantly
                      understandable through its simple, 10 bullet point
                      structure.
                    </li>
                    <li className="w-full">
                      It’s bite-sized inspiration that you can easily retain
                      with no fluff and no wasted time.
                    </li>
                    <li className="w-full">
                      Memo’d is designed to streamline your expertise so that
                      your insights can be easily learned and shared by anyone.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="about-hr" />

        <div className="memos-on-memod mx-auto mb-40">
          <div className="mb-3 space-y-3 text-center">
            <h1 className="h0 text-white">Memos on Memo'd</h1>
            <p className="text-memod-label">
              Learn more about the origins of the platform, the big ideas behind
              its inception, and everything Memo'd has to
              <br className="d-none d-lg-block" />
              offer knowledge-seekers like you.
            </p>
          </div>
          <div className="row mx-auto mt-16 flex flex-col space-y-2 lg:flex-row lg:space-x-8 lg:space-y-0">
            {memos.map((memo) => (
              <div className="mx-auto">
                <MemodCard memo={memo} memoWriter={memo.writer} />
              </div>
            ))}
          </div>
        </div>
      </main>
    </CommonLayout>
  );
};

export default AboutUs;
